import axios from '../axios'
import appConfig from 'app.config'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { logError } from 'shared/AppInsight'
import { CountryA3 } from 'shared/constants/countryTypes'

export interface CashToAccountFinalParams {
	partyId: string
	accountAgreementId: string
	market: CountryA3 | undefined
	amount: number
	nameOnReferenceAccount: string
	referenceAccountIban: string
}

export interface CashToAccountFinalResponse {
	state: 'Unknown' | 'Approved' | 'Denied' | 'Investigation'
	message: string | null | undefined
}

export async function cashToAccountFinal(params: CashToAccountFinalParams) {
	return axios
		.post<CashToAccountFinalResponse>(
			`${appConfig.customerDataBaseUrl}/api/CashToAccount/decision/final`,
			params,
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
